import React, { useEffect, useState } from 'react';

import { ProductAnalogyCard as Analogy } from "../../../widgets/ProductAnalogyCard/ProductAnalogyCard.tsx";
import Preloader from "../../../ui/Loader/Preloader.tsx";
import { LimitPages } from "../../../widgets/LimitPages/LimitPages.tsx";

interface Props {
    analogs: { id: number, brandId: number }[],
    branchId: number,
    filteredBrandsIds: number[],
}

export const Alternatives: React.FC<Props> = ({
    analogs,
    branchId,
    filteredBrandsIds,
}) => {
    const STEP = 5;
    const [maxPage, setMaxPage] = useState(1);
    const [page, setPage] = useState(1);
    const [loadingAnalogsCount, setLoadingAnalogsCount] = useState<number[]>([]);
    const [loadingAnalogsTitle, setLoadingAnalogsTitle] = useState<string>('');

    const increaseLoadingAnalogsCount = (id: number) => {
        if (!loadingAnalogsCount.includes(id)) loadingAnalogsCount.push(id);
        setLoadingAnalogsCount(loadingAnalogsCount);
        setLoadingAnalogsTitle(`Загрузка аналогов (${loadingAnalogsCount.length} из ${analogs.length})`);
        loadingAnalogsCount.length < (STEP * page) ? setLoadingAnalogsTitle(`Загрузка аналогов...`) : setLoadingAnalogsTitle('');
    }

    const openNextPage = (page: number) => {
        setPage(page);
    }

    useEffect(() => {
        setMaxPage(Math.ceil(analogs.length / STEP));
    }, [analogs, filteredBrandsIds]);

    return (
        <div className='w-full max-w-5xl'>
            <h4 className="font-bold text-xl mb-6">Аналоги от производителей</h4>
            {
                analogs.map((analog, key) => {
                    if ((key > (page * STEP) && !filteredBrandsIds.length) || filteredBrandsIds.length && !filteredBrandsIds.includes(analog.brandId)) return null;

                    return (analog && <Analogy
                        productId={analog.id}
                        branchId={branchId}
                        increaseLoadingAnalogsCount={increaseLoadingAnalogsCount}
                    />)
                })
            }
            {
                loadingAnalogsTitle
                    ? <Preloader title={loadingAnalogsTitle} customStyles={{ position: 'relative' }} />
                    : null
            }
            {
                !filteredBrandsIds.length
                    ? <div style={{ textAlign: 'center', marginTop: 24, }}>
                        <LimitPages maxPage={maxPage} openNextPage={openNextPage} page={page} />
                    </div>
                    : null
            }
        </div>
    );
};